"use strict";

var _interopRequireDefault = require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/work/code/aihuz/arbitration-ui/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _court = require("@/api/court.js");
var _Tinymce = _interopRequireDefault(require("@/components/Tinymce"));
var _dictionary = require("@/config/dictionary");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

require('@/utils/meet/meetnow.global.js');
require('@/utils/meet/meetnow.umd.js');
var ua = null;
var conf = null;
var number = '',
  password = '',
  displayName = '';
var user = {},
  users = {},
  confStatus = 'disconnected';
var sharing = false;
var _default = {
  data: function data() {
    return {
      hour: 0,
      minutes: 0,
      second: 0,
      dialogFormVisible: false,
      courtVisible: false,
      form: {
        type: ''
      },
      dialogVisible: false,
      allDetail: '',
      //案件详情
      conferenceDetail: '',
      //会议详情
      party: [],
      materialTabList: ['全部', '申请人提交', '被申请人提交', '仲裁庭提交'],
      partyIdType: _dictionary.dictionary.partyIdType,
      //申请人类型
      materialTab: 0,
      materialList: [],
      appProofFileList: [],
      //申请人材料
      resProofFileList: [],
      //被申请人材料
      caseArbitralFilesDtoList: [],
      //仲裁庭材料
      ua: '',
      conferenceId: '',
      caseId: '',
      currentRole: localStorage.getItem('role'),
      closeAll: true,
      //全局关闭麦克风
      recordContent: '',
      //庭审笔录
      initRecord: false,
      ws: '',
      wsPartyList: ''
    };
  },
  components: {
    Tinymce: _Tinymce.default
  },
  created: function () {
    var _created = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            MeetNow.setup();
            this.conferenceId = this.$route.params.id;
            this.caseId = this.$route.params.caseid;
            this.ua = MeetNow.createUA();
            _context.next = 6;
            return this.getPartyList();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2() {
      return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            this.getConferDetail();
            this.getCaseDetail();
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  beforeDestroy: function beforeDestroy() {
    this.leave();
    if (this.ws) {
      this.ws.onclose();
    }
  },
  destroyed: function destroyed() {
    var _this = this;
    this.leave();
    var sendobj = {
      "handleType": "n_destroy",
      "conferenceId": this.conferenceId
    };
    this.ws.send(JSON.stringify(sendobj));
    this.ws.onmessage = function (e) {
      console.log("destroyed:结果");
      console.log(e);
      _this.ws.onclose();
    };
  },
  methods: {
    //初始化websocket
    initSocket: function initSocket() {
      var _this2 = this;
      if (this.conferenceDetail.state != 1) {
        console.log("会议未开始，不加入socket");
        return;
      }
      if (window.WebSocket) {
        this.ws = new WebSocket(process.env.VUE_APP_BASE_SOCKET_API);
        this.ws.onopen = function (e) {
          console.log("连接服务器成功");
          var obj = {
            "handleType": "n_register",
            "conferenceId": _this2.conferenceId,
            "token": localStorage.getItem('token')
          };
          _this2.ws.send(JSON.stringify(obj));
        };
        this.ws.onmessage = this.websocketonmessage;
        this.ws.onclose = function (e) {
          console.log("服务器关闭");
        };
        this.ws.onerror = function () {
          _this2.$confirm('视频实时连接出错，是否重新连接?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this2.initSocket();
          }).catch(function () {
            _this2.$message({
              type: 'info',
              message: '已取消!'
            });
          });
        };
      } else {}
    },
    websocketonmessage: function websocketonmessage(e) {
      var _this3 = this;
      //数据接收
      console.log('接受新消息成功');
      console.log(e);
      var data = JSON.parse(e.data);
      if (data.type == 'N_USER_LIST') {
        this.getPartyList();
        if (data) {
          this.wsPartyList = JSON.parse(e.data);
          console.log(this.wsPartyList);
          if (this.wsPartyList.data) {
            this.party.forEach(function (ele) {
              ele.userEntity = 0;
              _this3.wsPartyList.data.forEach(function (item) {
                if (item.partyId == ele.id) {
                  ele.userEntity = 1;
                }
              });
            });
          }
        }
      }
    },
    //点击开始庭审
    startCourt: function startCourt() {
      var _this4 = this;
      (0, _court.getConferenceAddress)({
        id: this.conferenceId
      }).then(function (res) {
        if (res.code == 1) {
          number = res.data.conferenceNo;
          password = res.data.conferencePwd;
          displayName = localStorage.getItem('name');
          _this4.courtVisible = true;
          _this4.conferenceDetail = res.data;
          _this4.initLocalStream();
          _this4.join();
          _this4.initSocket();
        } else {
          _this4.$message.error(res.msg);
        }
      });
    },
    //获取会议详情
    getConferDetail: function getConferDetail() {
      var _this5 = this;
      (0, _court.getConferenceDetail)(this.conferenceId).then(function (res) {
        if (res.code == 1) {
          number = res.data.conferenceNo;
          password = res.data.conferencePwd;
          displayName = localStorage.getItem('name');
          _this5.conferenceDetail = res.data;
          if (res.data.state == 1) {
            _this5.courtVisible = true;
            _this5.initLocalStream();
            _this5.join();
            _this5.initSocket();
          }
        }
      });
    },
    //获取案件详情
    getCaseDetail: function getCaseDetail() {
      var _this6 = this;
      (0, _court.getConferenceCaseDetail)({
        caseId: this.caseId
      }).then(function (res) {
        if (res.code == 1) {
          _this6.allDetail = res.data;
          _this6.appProofFileList = res.data.appProofFileList;
          _this6.resProofFileList = res.data.resProofFileList;
          _this6.caseArbitralFilesDtoList = res.data.caseArbitralFilesDtoList;
          _this6.materialList = res.data.appProofFileList.concat(res.data.resProofFileList).concat(res.data.caseArbitralFilesDtoList);
        }
      });
    },
    //获取参与人
    getPartyList: function getPartyList() {
      var _this7 = this;
      (0, _court.getConferenceParty)(this.conferenceId).then(function (res) {
        if (res.code == 1) {
          _this7.party = res.data;
          /*this.ws.onmessage = (e) => {
            console.log('接受消息成功')
            console.log(e)
            if (e.data.charAt(0) == '{') {
              console.log('我进来了')
              this.wsPartyList = JSON.parse(e.data);
              console.log(this.wsPartyList)
              this.party.forEach((ele) => {
                ele.userEntity = 0;
                this.wsPartyList.data.forEach((item) => {
                  if (item.partyId == ele.id) {
                    ele.userEntity = 1;
                  }
                })
              })
            }
          }*/
        }
      });
    },
    controlVideoMain: function controlVideoMain(val) {
      var _this8 = this;
      var obj = {
        conferenceUuid: this.conferenceDetail.conferenceUuid,
        ylEntityId: val.userEntity
      };
      (0, _court.controlFocusVideo)(obj).then(function (res) {
        if (res.code == 1) {
          _this8.$message({
            message: '操作成功！',
            type: 'success'
          });
        } else {
          _this8.$message.error(res.msg);
        }
      });
    },
    // 控制音频和视频按键
    controlBtn: function controlBtn(val, type) {
      var _this9 = this;
      var obj;
      if (type == '关闭摄像头') {
        obj = {
          type: 1,
          status: 0,
          conferenceId: this.conferenceId,
          ylEntityId: val.userEntity
        };
      } else if (type == '开启麦克风') {
        obj = {
          type: 2,
          status: 1,
          conferenceId: this.conferenceId,
          ylEntityId: val.userEntity
        };
      } else if (type == '关闭麦克风') {
        obj = {
          type: 2,
          status: 0,
          conferenceId: this.conferenceId,
          ylEntityId: val.userEntity
        };
      } else if (type == '开启摄像头') {
        obj = {
          type: 1,
          status: 1,
          conferenceId: this.conferenceId,
          ylEntityId: val.userEntity
        };
      } else if (type == '举手发言') {
        var sendobj = {
          "handleType": "n_handing",
          "conferenceId": this.conferenceId
        };
        this.ws.send(JSON.stringify(sendobj));
        this.ws.onmessage = function (e) {
          _this9.$message({
            message: '举手操作成功！',
            type: 'success'
          });
        };
      }
      if (obj) {
        console.log(obj);
        (0, _court.controlVideoAudio)(obj).then(function (res) {
          if (res.code == 1) {
            _this9.$message({
              message: '操作成功！',
              type: 'success'
            });
          } else {
            _this9.$message.error(res.msg);
          }
        });
      }
    },
    //全局关闭麦克风
    controlBtnAll: function controlBtnAll(val) {
      var _this10 = this;
      var obj;
      if (val == 1) {
        obj = {
          status: 0,
          conferenceId: this.conferenceId
        };
        (0, _court.controlAudioAll)(obj).then(function (res) {
          if (res.code == 1) {
            _this10.closeAll = false;
            _this10.$message({
              message: '操作成功！',
              type: 'success'
            });
          } else {
            _this10.$message.error(res.msg);
          }
        });
      } else if (val == 2) {
        obj = {
          status: 1,
          conferenceId: this.conferenceId
        };
        (0, _court.controlAudioAll)(obj).then(function (res) {
          if (res.code == 1) {
            _this10.closeAll = true;
            _this10.$message({
              message: '操作成功！',
              type: 'success'
            });
          } else {
            _this10.$message.error(res.msg);
          }
        });
      }
    },
    //查询笔录
    checkRecord: function checkRecord() {
      var _this11 = this;
      (0, _court.getRecordContent)(this.conferenceId).then(function (res) {
        if (res.code == 1 && res.data.desc) {
          _this11.recordContent = res.data.desc;
          _this11.$refs.tinymce.setContent(_this11.recordContent);
        } else {
          _this11.recordContent = '';
          _this11.$refs.tinymce.setContent(_this11.recordContent);
          _this11.$message.error('暂时没有笔录！');
        }
      });
    },
    //保存笔录
    saveRecord: function saveRecord() {
      var _this12 = this;
      (0, _court.saveRecordContent)({
        conferenceId: this.conferenceId,
        desc: this.recordContent,
        state: 1
      }).then(function (res) {
        if (res.code == 1) {
          _this12.closeAll = true;
          _this12.$message({
            message: '保存成功！',
            type: 'success'
          });
        } else {
          _this12.$message.error('笔录内容不可为空！');
        }
      });
    },
    //加入视频
    join: function () {
      var _join = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(confStatus !== 'disconnected' || !number || !displayName)) {
                _context3.next = 3;
                break;
              }
              console.error('join() error');
              return _context3.abrupt("return");
            case 3:
              _context3.next = 5;
              return this.ua.connect({
                number: number,
                password: password,
                displayName: displayName
              });
            case 5:
              conf = _context3.sent;
              this.initBindEvent(conf);
              _context3.next = 9;
              return conf.join();
            case 9:
              if (!conf.mediaChannel) {
                _context3.next = 12;
                break;
              }
              _context3.next = 12;
              return conf.mediaChannel.connect();
            case 12:
              if (!conf.shareChannel) {
                _context3.next = 15;
                break;
              }
              _context3.next = 15;
              return conf.shareChannel.connect({
                mediaConstraints: {}
              });
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function join() {
        return _join.apply(this, arguments);
      }
      return join;
    }(),
    //离开视频
    leave: function leave() {
      if (!user || confStatus !== 'connected') {
        console.error('leave() error');
        return;
      }
      var hasPermission = user.isOrganizer() || user.isPresenter();
      if (hasPermission) conf.end();else conf.leave();
    },
    //初始化本地视频流
    initLocalStream: function initLocalStream() {
      var constraints = {
        audio: true,
        video: true
      };
      navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream) {
        var localVideo = document.querySelector('.local-video');
        if (!localVideo) return;
        localVideo.srcObject = mediaStream;
        localVideo.onloadedmetadata = function (e) {
          localVideo.play();
        };
      }).catch(function (error) {
        console.error(error);
      });
    },
    //初始化绑定
    initBindEvent: function initBindEvent(conf) {
      conf.on('connecting', function () {
        confStatus = 'connecting';
        console.warn('connecting');
      });
      conf.on('disconnecting', function () {
        confStatus = 'disconnecting';
        console.warn('disconnecting');
      });
      conf.on('disconnected', function () {
        confStatus = 'disconnected';
        console.warn('disconnected');
        conf = null;
        console.log('conf', conf);
        console.log('confStatus', confStatus);
      });
      conf.on('connected', function () {
        confStatus = 'connected';
        console.warn('connected');
        conf.on('error', function () {
          console.warn('error');
        });

        // 辅流
        // remotestream
        conf.shareChannel.on('remotestream', function (stream) {
          console.warn('shareChannel - remotestream', conf.state.getSharingUserEntity(), stream);
        });
        conf.users.on('updated', function (data) {
          console.warn('updated', data);
          user = conf.user;
          users = conf.users;
        });
        conf.users.on('user:added', function () {
          console.warn('user:added');
          users = conf.users;
        });
        conf.users.on('user:updated', function () {
          console.warn('user:updated');
        });
        conf.users.on('user:deleted', function () {
          console.warn('user:deleted');
          users = conf.users;
        });
        conf.mediaChannel.on('localstream', function (stream) {
          console.warn('localstream');
          var localVideo = document.querySelector('.local-video');
          localVideo.srcObject = stream;
        });
        conf.mediaChannel.on('remotestream', function (stream) {
          console.warn('remotestream');
          var remoteVideo = document.querySelector('.remote-video');
          remoteVideo.srcObject = stream;
        });
      });

      // 辅流
      // sharinguser
      conf.on('sharinguser', function (data, val) {
        console.warn('sharinguser');

        // 普通辅流 data 为分享辅流用户 User | 白板协作 data 为 空， val为白板用户 entity
        // 如需支持白板，必须进行如下判断
        sharing = data && data.getEntity() || val ? true : false;
        var shareVideo = document.querySelector('.share-video');
        if (sharing) {
          var stream = conf.shareChannel.getRemoteStream();
          console.log('sharing stream', stream);
          shareVideo.srcObject = stream;
        } else {
          shareVideo.srcObject = null;
        }
      });

      // currentUser
      conf.on('user', function (data) {
        console.warn('user', data);
        console.warn('user', data.isCurrent());
        users = conf.users;
        conf.user.on('updated', function (data) {
          console.warn('updated', data);
        });
        conf.user.on('displayTextChanged', function () {
          console.warn('displayTextChanged');
        });
        conf.user.on('roleChanged', function () {
          console.warn('roleChanged');
        });
        conf.user.on('holdChanged', function () {
          console.warn('holdChanged');
        });
        conf.user.on('handupChanged', function (data) {
          console.warn('handupChanged', data);
        });
        conf.user.on('audioChanged', function () {
          console.warn('audioChanged');
        });
        conf.user.on('videoChanged', function () {
          console.warn('videoChanged');
        });
        conf.user.on('mediaChanged', function (data) {
          console.warn('mediaChanged', data);
        });
        conf.user.on('sharingChanged', function (data) {
          console.warn('sharingChanged', data);
        });
      });
      conf.on('added', function () {
        console.warn('added');
      });
      conf.on('updated', function () {
        console.warn('updated');
      });
      conf.on('deleted', function () {
        console.warn('deleted');
      });
      conf.on('information', function () {
        console.warn('information');
      });
      conf.on('message', function () {
        console.warn('message');
      });
    },
    //案件材料点击
    materialChange: function materialChange(val) {
      this.materialTab = val;
    },
    // 右侧tab点击
    tabClick: function tabClick(val) {
      if (val.label == '庭审笔录') {
        this.checkRecord();
      }
    },
    //结束会议
    endConferences: function endConferences() {
      var _this13 = this;
      (0, _court.endConference)(this.conferenceId).then(function (res) {
        if (res.code == 1) {
          _this13.$message({
            message: '操作成功！',
            type: 'success'
          });
          _this13.$store.dispatch('tagsView/delView', _this13.$route).then(function (_ref) {
            var visitedViews = _ref.visitedViews;
            _this13.$router.push({
              name: 'videoCourt'
            });
          });
        } else {
          _this13.$message.error(res.msg);
        }
      });
    },
    //邀请设备入会
    inviteEquipment: function inviteEquipment() {
      var _this14 = this;
      console.log(this.conferenceId);
      (0, _court.inviteEquipment)(this.conferenceId).then(function (res) {
        if (res.code == 1) {
          _this14.$message({
            message: '操作成功！',
            type: 'success'
          });
        } else {
          _this14.$message.error(res.msg);
        }
      });
    },
    //设置设备主屏
    setEquipmentFocus: function setEquipmentFocus() {
      var _this15 = this;
      (0, _court.setEquipmentFocus)(this.conferenceId).then(function (res) {
        if (res.code == 1) {
          _this15.$message({
            message: '操作成功！',
            type: 'success'
          });
        } else {
          _this15.$message.error(res.msg);
        }
      });
    }
  }
};
exports.default = _default;